module.exports = __webpack_public_path__ + "static/img/jcICON5.6a47940.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/data/jcICON5.png
// module id = MpeN
// module chunks = 49